const hbFeaturedProducts = document.querySelector("[js-hb-featured-products]");
if(hbFeaturedProducts) {
  const tabItems = document.querySelectorAll("[js-tab-item]");
  const tabPanels = document.querySelectorAll("[js-tab-panel]");

  tabItems.forEach( tabitem => tabitem.addEventListener("click", handleTabs));

  function handleTabs() {
    const tabIndex = this.getAttribute('data-tab-index');
    const activePanel = hbFeaturedProducts.querySelector(`[js-tab-panel][data-tab-index="${tabIndex}"]`);

    tabItems.forEach( el => el.classList.remove('selected'));
    tabPanels.forEach( el => el.classList.remove('selected'));

    this.classList.add('selected');
    activePanel.classList.add('selected');

    initSliders();
  };

  function initSliders() {
    const activePanel = hbFeaturedProducts.querySelector(`[js-tab-panel].selected`);
    const sliderCounts = activePanel.querySelectorAll('[data-featured-slider]');

    for (let index = 0; index < sliderCounts.length; index++) {
      const slider = activePanel.querySelector(`[data-featured-slider="${index + 1}"]`);
      new Flickity(slider, {
        prevNextButtons: true,
        adaptiveHeight: false,
        wrapAround: false,
        pageDots: true,
        contain: false,
        imagesLoaded: true,
        cellAlign: 'left'
      });
    }
  }

  initSliders();
}